export default __webpack_public_path__ + "static/media/caretDown.117fde90.svg";